/* Native disclosures remain open without JavaScript; desktop menus always stay visible. */
if (!customElements.get('lc-footer-navigation')) {
  customElements.define('lc-footer-navigation', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary || this.media) return;
      this.mobileOpen = false;
      this.media = window.matchMedia('(max-width: 749px)');
      this.onMediaChange = () => {
        if (this.wasMobile && !this.media.matches) this.mobileOpen = this.details.open;
        if (this.media.matches && !this.mobileOpen && this.details.contains(document.activeElement)) {
          this.summary.focus();
        }
        this.details.open = this.media.matches ? this.mobileOpen : true;
        this.wasMobile = this.media.matches;
      };
      this.onToggle = () => {
        if (this.media.matches) this.mobileOpen = this.details.open;
      };
      this.onKeyUp = (event) => {
        if (event.key !== 'Escape' || !this.media.matches || !this.details.open) return;
        this.details.open = false;
        this.mobileOpen = false;
        this.summary.focus();
        event.stopPropagation();
      };
      this.media.addEventListener('change', this.onMediaChange);
      this.details.addEventListener('toggle', this.onToggle);
      this.details.addEventListener('keyup', this.onKeyUp);
      this.onMediaChange();
    }

    disconnectedCallback() {
      if (!this.media) return;
      this.media.removeEventListener('change', this.onMediaChange);
      this.details.removeEventListener('toggle', this.onToggle);
      this.details.removeEventListener('keyup', this.onKeyUp);
      this.media = null;
    }
  });
}
